/* Flour & Fir theme scripts */
(function () {
  'use strict';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ---------- Gallery ---------- */
  function initGallery(scope) {
    var gallery = scope.querySelector('[data-gallery]');
    if (!gallery) return;
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = gallery.querySelectorAll('[data-slide]');
    var thumbs = gallery.querySelectorAll('[data-thumb]');
    var dots = gallery.querySelectorAll('.fnf-gallery__dot');
    if (!track || slides.length < 2) return;

    function setActive(i) {
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.getAttribute('data-thumb'), 10);
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        setActive(i);
      });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        setActive(Math.max(0, Math.min(slides.length - 1, i)));
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- Bundle tiers + add-ons ---------- */
  function initHero(hero) {
    var tiers = hero.querySelectorAll('.fnf-tier__input');
    var addons = hero.querySelectorAll('[data-addon]');
    var protectionNote = hero.querySelector('[data-protection-note]');
    var priceEl = hero.querySelector('[data-price]');
    var compareEl = hero.querySelector('[data-compare]');
    var saveEl = hero.querySelector('[data-save]');
    var stickyLabel = hero.querySelector('[data-sticky-label]');
    var stickyPrice = hero.querySelector('[data-sticky-price]');
    var errorEl = hero.querySelector('[data-error]');

    if (tiers.length && !hero.querySelector('.fnf-tier__input:checked')) tiers[0].checked = true;

    function current() { return hero.querySelector('.fnf-tier__input:checked'); }

    function update() {
      var t = current();
      if (!t) return;
      tiers.forEach(function (x) { x.closest('.fnf-tier').classList.toggle('is-selected', x === t); });
      var price = t.getAttribute('data-price') || '';
      var compare = t.getAttribute('data-compare') || '';
      var save = t.getAttribute('data-save') || '';
      if (priceEl) priceEl.textContent = price;
      if (compareEl) compareEl.textContent = compare;
      if (saveEl) {
        if (save) { saveEl.textContent = 'You save ' + save; saveEl.hidden = false; }
        else { saveEl.hidden = true; }
      }
      if (stickyLabel) stickyLabel.textContent = t.getAttribute('data-label') || '';
      if (stickyPrice) stickyPrice.textContent = price;

      var tierNum = t.getAttribute('data-tier');
      var protectionIncluded = t.getAttribute('data-protection') === 'true';
      addons.forEach(function (a) {
        var allowed = (a.getAttribute('data-tiers') || '').split(',').indexOf(tierNum) !== -1;
        if (protectionIncluded && a.getAttribute('data-protection-addon') === 'true') allowed = false;
        a.hidden = !allowed;
        if (!allowed) {
          var cb = a.querySelector('input');
          if (cb) cb.checked = false;
        }
      });
      if (protectionNote) protectionNote.hidden = !protectionIncluded;
    }

    tiers.forEach(function (t) { t.addEventListener('change', update); });
    update();

    /* external "select tier" buttons, e.g. the gift section */
    document.querySelectorAll('[data-select-tier]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var n = btn.getAttribute('data-select-tier');
        var target = hero.querySelector('.fnf-tier__input[data-tier="' + n + '"]');
        if (target) { target.checked = true; update(); }
      });
    });

    /* add to cart */
    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }

    function addToCart(btn) {
      var t = current();
      if (!t) return;
      var variantId = t.getAttribute('data-variant-id');
      if (!variantId) { showError('Please choose a bundle.'); return; }
      if (errorEl) errorEl.hidden = true;

      var label = t.getAttribute('data-label') || '';
      var items = [{ id: Number(variantId), quantity: 1, properties: { Bundle: label } }];

      (t.getAttribute('data-gifts') || '').split(',').forEach(function (id) {
        id = id.trim();
        if (id) items.push({ id: Number(id), quantity: 1, properties: { 'Free gift': 'Included with your ' + label } });
      });

      hero.querySelectorAll('[data-addon]:not([hidden]) .fnf-addon__input:checked').forEach(function (cb) {
        var id = cb.getAttribute('data-variant-id');
        if (id) items.push({ id: Number(id), quantity: 1 });
      });

      var attributes = { 'Shipping tier': t.getAttribute('data-shipping') || '' };
      if (t.getAttribute('data-protection') === 'true') attributes['Package protection'] = 'Included with bundle';

      var buttons = hero.querySelectorAll('[data-atc]');
      buttons.forEach(function (b) { b.classList.add('is-loading'); });

      var fresh = hero.getAttribute('data-fresh-cart') === 'true';
      var start = fresh
        ? fetch(root() + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        : Promise.resolve();

      start
        .then(function () {
          return fetch(root() + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong.');
            return data;
          });
        })
        .then(function () {
          return fetch(root() + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: attributes })
          });
        })
        .then(function () {
          var dest = hero.getAttribute('data-after-add') === 'checkout' ? 'checkout' : 'cart';
          window.location.href = root() + dest;
        })
        .catch(function (err) {
          buttons.forEach(function (b) { b.classList.remove('is-loading'); });
          showError(err.message + ' Please try again, or email us and we will help.');
        });
    }

    hero.querySelectorAll('[data-atc]').forEach(function (btn) {
      btn.addEventListener('click', function () { addToCart(btn); });
    });

    /* sticky bar */
    var sticky = hero.querySelector('[data-sticky]');
    var mainBtn = hero.querySelector('.fnf-atc');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      var footer = document.querySelector('.fnf-footer');
      var btnVisible = true, footerVisible = false;
      function render() {
        var show = !btnVisible && !footerVisible && mainBtn.getBoundingClientRect().top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sticky.querySelectorAll('button').forEach(function (b) { b.tabIndex = show ? 0 : -1; });
      }
      new IntersectionObserver(function (e) { btnVisible = e[0].isIntersecting; render(); }).observe(mainBtn);
      if (footer) new IntersectionObserver(function (e) { footerVisible = e[0].isIntersecting; render(); }).observe(footer);
    }
  }


  /* ---------- Announcement rotation ---------- */
  function initAnnounce() {
    document.querySelectorAll('[data-announce]').forEach(function (bar) {
      if (bar._fnfTimer) clearInterval(bar._fnfTimer);
      var msgs = bar.querySelectorAll('.fnf-announce__msg');
      if (msgs.length < 2) return;
      var i = 0;
      var secs = parseInt(bar.getAttribute('data-interval'), 10) || 4;
      bar._fnfTimer = setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, secs * 1000);
    });
  }

  function init() {
    initAnnounce();
    document.querySelectorAll('[data-fnf-hero]').forEach(function (hero) {
      initGallery(hero);
      initHero(hero);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* re-init in the theme editor */
  document.addEventListener('shopify:section:load', init);
})();
